'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _UIFlex = require('../layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _Selectors = require('../constants/Selectors');

var _decorators = require('../utils/propTypes/decorators');

var _customRenderer = require('../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _HoverProvider = require('../providers/HoverProvider');

var _HoverProvider2 = _interopRequireDefault(_HoverProvider);

var _FocusProvider = require('../providers/FocusProvider');

var _FocusProvider2 = _interopRequireDefault(_FocusProvider);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var USE_CLASSES = {
  default: '',
  'full-card': 'private-hoverlay--full-card',
  'bottom-half-card': 'private-hoverlay--bottom-half-card'
};

var UIHoverlay = function (_Component) {
  _inherits(UIHoverlay, _Component);

  function UIHoverlay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UIHoverlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UIHoverlay.__proto__ || Object.getPrototypeOf(UIHoverlay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasTabbableContent: false
    }, _this.refCallback = function (el) {
      if (!el) return;
      var hasTabbableContent = el.querySelector(_Selectors.FOCUSABLE);
      _this.setState({
        hasTabbableContent: hasTabbableContent
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UIHoverlay, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _blur = _props._blur,
          className = _props.className,
          children = _props.children,
          __focused = _props.focused,
          foregroundContent = _props.foregroundContent,
          __hovered = _props.hovered,
          href = _props.href,
          linkComponent = _props.linkComponent,
          onClick = _props.onClick,
          overlayClassName = _props.overlayClassName,
          tabIndex = _props.tabIndex,
          use = _props.use,
          rest = _objectWithoutProperties(_props, ['_blur', 'className', 'children', 'focused', 'foregroundContent', 'hovered', 'href', 'linkComponent', 'onClick', 'overlayClassName', 'tabIndex', 'use']);

      var hasTabbableContent = this.state.hasTabbableContent;


      if (process.env.NODE_ENV !== 'production') {
        if (href && onClick) {
          _devLogger2.default.warn({
            message: 'UIHoverlay: Cannot have both onClick and href props.'
          });
        }
      }

      return _react2.default.createElement(
        _HoverProvider2.default,
        this.props,
        function (hoverProviderProps) {
          return _react2.default.createElement(
            _FocusProvider2.default,
            _this2.props,
            function (focusProviderProps) {
              var hovered = hoverProviderProps.hovered,
                  hoverProviderRestProps = _objectWithoutProperties(hoverProviderProps, ['hovered']);

              var focused = focusProviderProps.focused,
                  focusProviderRestProps = _objectWithoutProperties(focusProviderProps, ['focused']);

              var wrappedForegroundContent = foregroundContent == null ? null : _react2.default.createElement(
                'div',
                {
                  className: (0, _classnames2.default)(overlayClassName, 'uiOverlay-backdrop', 'private-hoverlay__overlay', 'private-overlay--contextual', {
                    'private-hoverlay__overlay--clickable': href || onClick,
                    'private-hoverlay__overlay--focused': focused,
                    'private-hoverlay__overlay--hovered': hovered
                  })
                },
                _react2.default.createElement(
                  _UIFlex2.default,
                  {
                    align: 'stretch',
                    direction: 'column',
                    justify: 'start',
                    className: (0, _classnames2.default)('private-overlay__overlay-content', 'private-hoverlay__foreground-content')
                  },
                  foregroundContent
                )
              );

              var renderedOverlay = _react2.default.createElement(
                'span',
                null,
                wrappedForegroundContent,
                _react2.default.createElement(
                  'div',
                  {
                    className: (0, _classnames2.default)('private-hoverlay__children', { 'private-hoverlay__children--blur': _blur }, { 'private-hoverlay--blur': _blur })
                  },
                  (0, _react.cloneElement)(children, {
                    className: (0, _classnames2.default)('private-hoverlay__child', children.props.className)
                  })
                )
              );

              var renderedHoverlay = void 0;
              if (href) {
                renderedHoverlay = CustomRenderer.render(linkComponent, {
                  children: renderedOverlay,
                  className: 'display-block',
                  href: href,
                  use: 'unstyled'
                });
              } else if (onClick) {
                renderedHoverlay = _react2.default.createElement(
                  _UIClickable2.default,
                  {
                    className: 'private-hoverlay__button',
                    onClick: onClick
                  },
                  renderedOverlay
                );
              } else {
                renderedHoverlay = renderedOverlay;
              }

              var computedTabIndex = void 0;
              if (tabIndex != null) {
                computedTabIndex = tabIndex;
              } else {
                computedTabIndex = hasTabbableContent ? null : 0;
              }

              return _react2.default.createElement(
                'div',
                _extends({}, rest, hoverProviderRestProps, focusProviderRestProps, {
                  className: (0, _classnames2.default)(className, 'private-hoverlay', USE_CLASSES[use], {
                    'is--module': use === 'full-card'
                  }),
                  ref: _this2.refCallback,
                  tabIndex: computedTabIndex
                }),
                renderedHoverlay
              );
            }
          );
        }
      );
    }
  }]);

  return UIHoverlay;
}(_react.Component);

UIHoverlay.propTypes = {
  _blur: _propTypes2.default.bool,
  children: _propTypes2.default.element,
  focused: (0, _decorators.hidden)(_propTypes2.default.bool),
  foregroundContent: _propTypes2.default.node,
  hovered: _propTypes2.default.bool,
  href: _propTypes2.default.oneOfType([_validHref2.default]),
  linkComponent: CustomRenderer.propType,
  overlayClassName: _propTypes2.default.string,
  use: _propTypes2.default.oneOf(Object.keys(USE_CLASSES))
};

UIHoverlay.defaultProps = {
  _blur: true,
  linkComponent: _UILink2.default,
  use: 'default'
};

UIHoverlay.displayName = 'UIHoverlay';

exports.default = UIHoverlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/overlay/UIHoverlay.js
// module id = 520
// module chunks = 177